import type { TRuleWithTheme } from '@/styles/theme';

export const labelRow: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',

    minHeight: '1.75rem',
});

export const file: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',

    minWidth: 0,
});

export const fileName: TRuleWithTheme = () => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const importButton: TRuleWithTheme = () => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    flexShrink: 0,

    height: 'auto',
    padding: 0,
});
